module.exports = extend

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/xtend/index.js
 ** module id = 92
 ** module chunks = 0
 **/